export function toMinorUnits(value) {
  if (value === "") return null;
  if (!/^\d{1,7}(\.\d{1,2})?$/.test(value)) throw new Error("Enter a price with up to two decimal places");
  const [whole, fraction = ""] = value.split(".");
  const amount = Number(whole) * 100 + Number((fraction + "00").slice(0, 2));
  if (amount > 100000000) throw new Error("Maximum price is 1,000,000");
  return amount;
}

export function formatPlanPrice(plan) {
  if (plan.tier === "free") return "Free";
  if (plan.amount == null) return "Pricing to be announced";
  return new Intl.NumberFormat(undefined, { style: "currency", currency: plan.currency }).format(plan.amount / 100);
}
